import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-sy",
  "use": "icon-icon-sy-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-sy\">\n  <path d=\"M0 0h512v512H0Z\" />\n  <path fill=\"#fff\" d=\"M0 0h512v341.3H0Z\" />\n  <path fill=\"#ce1126\" d=\"M0 0h512v170.7H0Z\" />\n  <path fill=\"#007a3d\" d=\"M86.4 320 128 192l41.6 128-108.9-79.1h134.6M342.4 320 384 192l41.6 128-108.9-79.1h134.6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol